export const aiTypes = {
  GET_CONNECTIONSTRING: "ai/GET_CONNECTIONSTRING",
};
